import { DataService } from 'api/DataService'

import browserQueryToQueryString from 'utils/query-string'

export class ProductLinkService {
  public static async deleteLink(uuid: string): Promise<any> {
    const response = await DataService({
      type: 'DELETE',
      url: `/v1/product_links/${uuid}`
    })

    return response
  }
  public static async getReports(uuid: string, query: any): Promise<any> {
    const response = await DataService({
      type: 'GET',
      url: `/v1/product_links/${uuid}/report${browserQueryToQueryString(
        query as { [key in string]: string }
      )}`
    })

    return response
  }
}
